import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $erc20 from '../erc20/index.js';
import $utils from "@/lib/utils/index.js";

const contractJson = require('./PledgePool.json')

let web3 = $web3js.getWeb3();
let contractAddress = $bizConfig.pledgePoolContractAddress;
let contractConst = {
  contract: web3 ? new web3.eth.Contract(contractJson.abi, contractAddress) : '',
}

const getpledgePoolAddress = () => {
  return contractAddress;
}

const getpledgePoolContract = () => {
  return contractConst.contract;
}

const userPledge = async ([pledgeContractAddress, _prodid, amount], options, callback) => {
  amount = await $erc20.toErc20Value(amount, pledgeContractAddress);
  return $web3js.send(getpledgePoolContract().methods.userPledge, [_prodid, amount], options, callback);
}

const userPledgeEstimateSend = async ([pledgeContractAddress, _prodid, amount], options) => {
  amount = await $erc20.toErc20Value(amount, pledgeContractAddress);

  let gasPromise = $web3js.estimateSend(getpledgePoolContract().methods.userPledge, [_prodid, amount], options);
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}

const pledgePooluserWithdraw = async ([_prodid], options, callback) => {
  return $web3js.send(getpledgePoolContract().methods.userWithdraw, [_prodid], options, callback);
}

const pledgePooluserWithdraweEstimateSend = async ([_prodid], options) => {
  let gasPromise = $web3js.estimateSend(getpledgePoolContract().methods.userWithdraw, [_prodid], options);
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}

const pledgePooluserPledgeFailWithdraw = async ([_prodid], options, callback) => {
  return $web3js.send(getpledgePoolContract().methods.userPledgeFailWithdraw, [_prodid], options, callback);
}

const pledgePooluserPledgeFailWithdrawEstimateSend = async ([_prodid], options) => {
  let gasPromise = $web3js.estimateSend(getpledgePoolContract().methods.userPledgeFailWithdraw, [_prodid], options);
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}

const pledgePooluserSettlementWithdraw = async ([_prodid], options, callback) => {
  return $web3js.send(getpledgePoolContract().methods.userSettlementWithdraw, [_prodid], options, callback);
}

const pledgePooluserSettlementWithdrawEstimateSend = async ([_prodid], options) => {
  let gasPromise = $web3js.estimateSend(getpledgePoolContract().methods.userSettlementWithdraw, [_prodid], options);
  let gasPricePromise = $web3js.getGasPrice();

  let [e1, gas] = await $utils.awaitWrap(gasPromise);
  let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
  if (!!e1) {
    Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
    return null;
  }

  let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
  return { gas, gasPrice, fee };
}

const getPledgePoolPledgeInfo = ([_prodid], options) => {
  return $web3js.call(getpledgePoolContract().methods.getPoolPledgeInfo, [_prodid], options);
}

const getPledgePoolgetUserPledgeInfo = ([_contractAddress, _prodid, _user], options) => {
  return $web3js.call(getpledgePoolContract().methods.getUserPledgeInfo, [_prodid, _user], options, $erc20.fromErc20Value, [_contractAddress]);
}

const handlelPledgePoolUserBenefitsInfo = ([pledgeContractAddress, pledgeBenefitContractAddress, projectBenefitContractAddress, _prodid, user], options) => {
  return $web3js.call(getpledgePoolContract().methods.getUserBenefitsInfo, [_prodid, user], options, handlelUserBenefitsInfo, [pledgeContractAddress, pledgeBenefitContractAddress, projectBenefitContractAddress]);
}

const handlelUserBenefitsInfo = async (res, pledgeContractAddress, pledgeBenefitContractAddress, projectBenefitContractAddress) => {
  let index = 0;
  let releasePrincipal = res[index++];
  let gainedPrincipal = res[index++];
  let availablePrincipal = res[index++];
  let gainedDmcBenefits = res[index++];
  let availableDmcBenefits = res[index++];
  let gainedXchBenefits = res[index++];
  let availableXchBenefits = res[index++];
  releasePrincipal = await $erc20.fromErc20Value(releasePrincipal, pledgeContractAddress);
  gainedPrincipal = await $erc20.fromErc20Value(gainedPrincipal, pledgeContractAddress);
  availablePrincipal = await $erc20.fromErc20Value(availablePrincipal, pledgeContractAddress);
  gainedDmcBenefits = await $erc20.fromErc20Value(gainedDmcBenefits, pledgeBenefitContractAddress);
  availableDmcBenefits = await $erc20.fromErc20Value(availableDmcBenefits, pledgeBenefitContractAddress);
  gainedXchBenefits = await $erc20.fromErc20Value(gainedXchBenefits, projectBenefitContractAddress);
  availableXchBenefits = await $erc20.fromErc20Value(availableXchBenefits, projectBenefitContractAddress);

  return {
    releasePrincipal,
    gainedPrincipal,
    availablePrincipal,
    gainedDmcBenefits,
    availableDmcBenefits,
    gainedXchBenefits,
    availableXchBenefits
  }
}

export default {
  getpledgePoolAddress,
  getpledgePoolContract,
  userPledge,
  userPledgeEstimateSend,
  getPledgePoolPledgeInfo,
  handlelPledgePoolUserBenefitsInfo,
  getPledgePoolgetUserPledgeInfo,
  pledgePooluserWithdraw,
  pledgePooluserWithdraweEstimateSend,
  pledgePooluserPledgeFailWithdraw,
  pledgePooluserPledgeFailWithdrawEstimateSend,
  pledgePooluserSettlementWithdraw,
  pledgePooluserSettlementWithdrawEstimateSend,
}


// WEBPACK FOOTER //
// ./src/lib/contract/pledgePool/index.js